import { CURR_PRODUCT_ADD, CURR_PRODUCT_DEL } from "../actions/curr_product_actions";


const initialState = {
  currProduct: {}
};


export const currProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case CURR_PRODUCT_ADD: {
      return {
        ...state,
        currProduct: {...action.currProduct}
      }
    }
    case CURR_PRODUCT_DEL: {
      return {
        ...state,
        currProduct: {}
      }
    }
    default: return state;
  }
}
